module.exports = __webpack_public_path__ + "img/publication-1.89f8180b.jpg";